import { render, staticRenderFns } from "./calendar-facet-day-font-weight.vue?vue&type=template&id=4811e03d&"
import script from "./calendar-facet-day-font-weight.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-day-font-weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports